//出店者の表示名・都道府県・プランは、メタオブジェクト shop_profile から Liquid で出力する
//（検索の案内：snippets/yeg-vendor-search-guide.liquid、商品ページ：templates/product.json、
//  エリアから探す：snippets/yeg-vendor-list.liquid）。プランは管理画面の shop_profile.plan で管理する。
//以下の API 呼び出しは、出店者ページの詳細とトップのプレミアムバナーでのみ使う。

function ajax_ms_yeg(vendor="", func=false){
	//出品者一覧
	let url = "https://ms-yeg.multi-suppliers.net/api/v1/merchants/";
	if(vendor){
		//出品者詳細
		url += vendor;
	}
	//console.log('API url = '+url);
	$.ajax({
		type: "GET",
		url	: url,
		data: {},
		dataType : "json"
	})
	.done(function(data){
		console.log('done');
		console.log(data);
		if(func){
			func(data);
		}else if(vendor){
			//詳細
			let shop_name = data['shop_name'];
			let title = $('title').text();
			title = title.replace(vendor, shop_name);
			$('title').text(title);
			
			for(let key in data){
				if(data[key] && $('#'+key).length>0){
					let $dom = $('#'+key);
					let v = data[key];
					switch(key){
						//case 'video_embed_html':
						//  break;
//						case 'banner_image_url':
//							console.log('banner_image_url='+v);
//							$('#banner_image_url').css({'backgroundImage':'url('+v+')'});
//							break;
						case 'shop_contact_info':
							$('#'+key).show();
							break;
						case 'description2':
							$dom.html('<hr>'+v);
							break;
						case 'banner_image_url':
						case 'profile_image_url':
						case 'desc_image_url':
						case 'desc2_image_url':
						case 'desc3_image_url':
						case 'desc4_image_url':
							$dom.html('<img src="'+v+'" alt="'+shop_name+'">');
							break;
						case 'shop_name':
							$('#contact-modal-title').html(v);
						default:
							$dom.html(v);
							break;
					}
				}else{
					console.log(key + '未使用');
					//$('#'+key).html('未使用');//.hide();
					$('#'+key).hide();
				}
			}
		}
	})
	.fail(function(xhr, status, error){
		console.log(xhr, status, error);
	});
}

//表示中の言語のルート（日本語 "/"、英語 "/en/"。末尾スラッシュあり）
function locale_root(){
	return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
}

function vendor_box_html(d){
	//short_name, shop_name, shop_name_kana, shop_prefecture, shop_genre_category, shop_genre_category_sub, profile_image_url, description, description2, shop_prefecture_code
	let im = '<span class="no-img tmb"></span>';
	if(d['profile_image_url']){
		im = '<img src="'+d['profile_image_url']+'" alt="'+d['shop_name']+'" class="tmb">';
	}
	return '<div id="vendor-'+d['short_name']+'" class="vendor-box pref-'+d['shop_prefecture_code']+'">'+
			'<a href="'+locale_root()+'collections/vendors?q='+encodeURIComponent(d['short_name'])+'">'+
				im+
				'<h3 class="shop_name">'+d['shop_name']+'</h3>'+
				'<div class="vendor-category">'+
					'<span class="badge shop_genre_category">'+d['shop_genre_category']+'</span>'+
					'<span class="badge shop_genre_category_sub">'+d['shop_genre_category_sub']+'</span>'+
				'</div>'+
//				'<hr style="margin:1rem 0;">Debug<br>'+
//				'<div><span class="badge">'+d['plan_name']+'</span></div>'+
//				'<div><span class="badge">'+d['shop_name_kana']+'</span></div>'+
//				'<div>'+
//					'<span class="badge badge-pref">'+d['shop_prefecture']+'</span>'+
//				'</div>'+
			'</a>'+
		'</div>';
}

document.addEventListener('DOMContentLoaded', function(){
	console.log('yeg-init');
	/* home/vender_banners premium_stores
	----------------------------------------------- */
	if($('.vendor-bnrs').length>0){
		console.log('#vendor-プレミアムバナー生成');
		let obj = {};
		$('.vendor-bnrs>span').each(function(){
			let id = $(this).attr('class');
			obj[id] = {
				img:$(this).data('img')
			}
		})
		let store = Object.keys(obj);
		//console.log('obj___');
		//console.log(obj);
		//console.log('store___');
		//console.log(store);
		
		let func = function(data){
			for(let key in data){
				let short_name = data[key]['short_name'];
				let show = (store && store.indexOf(short_name) === -1) ? false : true ;
				if(show){
					data[key]['profile_image_url'] = obj[short_name].img;
					let html = vendor_box_html(data[key]);
					$('.vendor-bnrs>span.'+short_name).replaceWith(html)
				}
			}
		}
		ajax_ms_yeg("", func);
	}

	/* coupon
	----------------------------------------------- */
/*
	$('.product-grid [data-vendor]').each(function(){
		let vendor = $(this).data('vendor');
		if(is_coupon(vendor)){
			$('.card__media',$(this)).append('<span class="ic-coupon"></span>');
		}
	})
	if($('.coupon-info').length>0){
		let vendor = $('.coupon-info').data('vendor');
		if(is_coupon(vendor)){
			$('.coupon-info').addClass('show');
		}
	}
*/

	/* search
	----------------------------------------------- */
	$(document)
		.on('click', '.search-link', function(){
			let f = $('form.search');
			$('[name=q]',f).val($(this).text());
			//console.log(f.serialize());
			f.submit();
		})
		.on('click', '.filter-pref', function(){
			//console.log('click.filter-pref');
			$('.filter-pref').removeClass('active');
			$(this).addClass('active');
			let pref = $(this).data('pref');
			let key = (pref == 'all') ? 'vendor-box' : 'pref-'+pref;
			$('.vendor-box').each(function(){
				if($(this).hasClass(key)){
					$(this).removeClass('hide');
				}else{
					$(this).addClass('hide');
				}
			})
			//結果表示
			let pref_name = (pref == 'all') ? '全国' : $(this).text() ;
			$('#search-results span').text(pref_name);
		})
		//modal
		.on('click', '.modal-container', function(e){
			e.stopPropagation();
		})
		.on('click', '.js-modal-open', function(){
			let m = $(this).data('modal');
			if(m && $(m).length>0){
				$(m).addClass('active');
			}
		})
		.on('click', '.js-modal-close, .js-modal', function(){
			$('.js-modal').removeClass('active');
		})

	/* collection-random
	----------------------------------------------- */
	$('.collection-random').each(function(){
		let $dom = $('.product-grid',$(this));
		let $items = $dom.children();
		$items.sort(function(){
			return 0.5 - Math.random();
		});
		$dom.html($items).css({visibility:'visible'});
	});
	/*
	js version
	特定の要素のappendChild(最後尾)、insertBefore（前に挿入）
	※ 既に存在する要素に使用すると元の位置からは消えて新しい位置に追加される=>移動
	*/
	/*
	const limit = 3;
	const productGrid = document.querySelector('.product-grid');  // 商品リストの親要素を指定
	if (!productGrid) return;
	
	const products = Array.from(productGrid.children); // 商品要素を配列に変換
	products.sort(() => Math.random() - 0.5); // 商品をランダムに並べ替え
	products.forEach(product => productGrid.appendChild(product)); // 並べ替えた商品を再度親要素に追加
	*/
	
});


//公式:https://swiperjs.com/
//参考:https://kiomiru.co.jp/blog/coding/swiper-js/
/* swiper cover
-------------------------------------------------------------- */
let cover_swiper = new Swiper(".cover-swiper", {
	loop:true,
	slidesPerView: "auto",
	centeredSlides: true,
	speed:1000,
	autoplay: {
		delay:5000, //スライドが切り替わるまでの時間
	},
	spaceBetween: 30,
	pagination: {
		el: ".cover-swiper .swiper-pagination",
		clickable: true,
	},
});

const test_swiper_id = ".test-swiper";
let test_swiper = new Swiper(test_swiper_id, {
    centeredSlides: true,
    slidesPerView: 1.8,
    spaceBetween: 30,
    loop: true,
	pagination: {
		el: test_swiper_id + " .swiper-pagination",
		clickable: true,
	},
});
